module.exports = __webpack_public_path__ + "static/img/dyInfo02.d63d2e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/dyInfo02.jpg
// module id = JRVD
// module chunks = 0